import { MESSAGE_BOX_SHOW, MESSAGE_BOX_HIDE } from './type'

/**
 *
 * @param {*} content
 */
export const messageBoxShowAction = content => {
  return {
    type: MESSAGE_BOX_SHOW,
    payload: { content },
  }
}

/**
 *
 */
export const messageBoxHideAction = id => {
  return {
    type: MESSAGE_BOX_HIDE,
    payload: { id },
  }
}
